/**
 * <<uppercase_module_name>> Module
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import {
    getLogTemplates,
    getLogTemplate,
    printLogTemplate,
    createLogTemplates,
    updateLogTemplates,
    deleteLogTemplates,
    createLogTemplateDetail,
    updateLogTemplateDetail,
    deleteLogTemplateDetail,
} from "Modules/configuration/log_templates/config/api.log_templates";

const state = {
    page: {},
    form: {},
    log_templates: [],
    log_template_options: [],
    selectedLogTemplate: {
        template_id: null,
        company_id: "",
        log_template_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        log_template_details: [],
    },
    log_templates_filter: {
        search: "",
        page_size: 2,
        page_num: 1,
    },
    rules_log_templates: {
        template_id: {
            name: "template_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        template_name: {
            name: "template_name",
            rules: "trim|max_length[65]|required",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        slug: {
            name: "slug",
            rules: "trim|max_length[36]|required",
            max_len: "36",
            min_len: "",
            default_value: "",
        },
        image: {
            name: "image",
            rules: "trim|max_length[650000]",
            max_len: "650000",
            min_len: "",
            default_value: "",
        },
        version: {
            name: "version",
            rules: "trim|max_length[4]|integer|required",
            max_len: "4",
            min_len: "",
            default_value: "",
        },
        active: {
            name: "active",
            rules: "trim|max_length[1]|integer|required",
            max_len: "1",
            min_len: "",
            default_value: "1",
        },
        capture: {
            name: "capture",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        frequency_interval: {
            name: "frequency_interval",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        frequency: {
            name: "frequency",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        log_templates_detail: {
            detail_template_id: {
                name: "detail_template_id",
                rules: "trim|max_length[15]|integer|required",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
            template_id: {
                name: "template_id",
                rules: "trim|max_length[15]|integer|required",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
            question: {
                name: "question",
                rules: "trim|max_length[255]|required",
                max_len: "255",
                min_len: "",
                default_value: "",
            },
            element_type: {
                name: "element_type",
                rules: "trim|max_length[255]|required",
                max_len: "255",
                min_len: "",
                default_value: "",
            },
            element_rules: {
                name: "element_rules",
                rules: "trim|max_length[255]",
                max_len: "255",
                min_len: "",
                default_value: "",
            },
            options: {
                name: "options",
                rules: "trim|max_length[255]",
                max_len: "255",
                min_len: "",
                default_value: "",
            },
            required: {
                name: "required",
                rules: "trim|max_length[1]|integer|required",
                max_len: "1",
                min_len: "",
                default_value: "1",
            },
            sort_order: {
                name: "sort_order",
                rules: "trim|max_length[3]|integer|required",
                max_len: "3",
                min_len: "",
                default_value: "",
            },
            method: {
                name: "method",
                rules: "trim|max_length[255]",
                max_len: "255",
                min_len: "",
                default_value: "",
            },
            parameter: {
                name: "parameter",
                rules: "trim|max_length[255]",
                max_len: "255",
                min_len: "",
                default_value: "",
            },
        },
    },
    rules_log_templates_detail: {
        detail_template_id: {
            name: "detail_template_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        template_id: {
            name: "template_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        question: {
            name: "question",
            rules: "trim|max_length[255]|required",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        element_type: {
            name: "element_type",
            rules: "trim|max_length[255]|required",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        element_rules: {
            name: "element_rules",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        options: {
            name: "options",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        required: {
            name: "required",
            rules: "trim|max_length[1]|integer|required",
            max_len: "1",
            min_len: "",
            default_value: "1",
        },
        method: {
            name: "method",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        parameter: {
            name: "parameter",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        frequency_interval: {
            name: "frequency_interval",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        frequency: {
            name: "frequency",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
    },
};

// getters
const getters = {
    log_templates: (state) => {
        return state.log_templates;
    },
};

// actions
const actions = {
    async fetchLogTemplates({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getLogTemplates({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("mutate", {
                        property: "page",
                        with: response.data.page,
                    });
                }

                if (body.options) {
                    commit("mutate", {
                        property: "log_template_options",
                        with: response.data.log_templates,
                    });
                } else {
                    commit("mutate", {
                        property: "log_templates",
                        with: response.data.log_templates,
                    });
                }

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log(error);
            console.log("fetch all error");
            return;
        }
    },
    async fetchLogTemplate({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getLogTemplate(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("mutate", {
                    property: "selectedLogTemplate",
                    with: response.data.log_template,
                });
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printLogTemplate({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printLogTemplate(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveLogTemplate({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["template_id"] === "undefined" || body["template_id"] == null || body["template_id"] == "") {
                delete body["template_id"];
                response = await createLogTemplates({ body: body, headers: config.headers });
            } else {
                let template_id = body["template_id"];
                delete body["template_id"];
                response = await updateLogTemplates({ body: body, headers: config.headers }, template_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async saveLogTemplateDetail({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["detail_template_id"] === "undefined" || body["detail_template_id"] == null || body["detail_template_id"] == "") {
                delete body["detail_template_id"];
                response = await createLogTemplateDetail({ body: body, headers: config.headers });
            } else {
                let template_id = body["detail_template_id"];
                delete body["detail_template_id"];
                response = await updateLogTemplateDetail({ body: body, headers: config.headers }, template_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteLogTemplate({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteLogTemplates(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
    async deleteLogTemplatesDetail({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };
            response = await deleteLogTemplateDetail(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    mutate(state, payload) {
        state[payload.property] = payload.with;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
